export const SOCURE_PUBLIC_KEY = process.env.NEXT_PUBLIC_SOCURE_PUBLIC_KEY;
export const SOCURE_ENDPOINT = 'https://s.risk.onefootprint.com/';
